export enum CLASSES {
  INPUT_ERROR = 'form__input--has-error',
  INPUT_ERROR_TOOLTIP = 'form__input-error',
  THROBBER_MAIN = 'throbber',
  PANEL_CONTAINER = 'panel__container',
  ACTIVE = 'active',
  DISABLED = 'disabled',
}
